import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { PlacesQuery } from '../../../../../apollo/__generated__/graphql';
import { useUpdatePlaceMutation } from '../../../../hooks/useUpdatePlaceMutation';
import { PlaceFormInputs } from '../PlaceForm/PlaceForm';

const schema = yup
  .object({
    name: yup.string().required('Le nom du lieu est requis'),
    address: yup.string().required("L'adresse est requise"),
  })
  .required();

export const useEditPlaceDrawer = (
  place: PlacesQuery['places'][number],
  onClose: () => void,
) => {
  const { updatePlace } = useUpdatePlaceMutation(() => {
    onClose();
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PlaceFormInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: place.name,
      address: place.address,
    },
  });

  const onValid: SubmitHandler<PlaceFormInputs> = async (data) => {
    updatePlace({ placeId: place.id, ...data });
  };
  const onSubmit = handleSubmit(onValid);

  return {
    register,
    errors,
    onSubmit,
  };
};
